const isMobileDevice = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  // Check for iOS devices
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as Window & {
    MSStream?: unknown;
  }).MSStream;

  // Check for Android devices
  const isAndroid = /Android/i.test(navigator.userAgent);

  // Check for touch capability as additional mobile indicator
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Check for mobile user agent patterns
  const isMobileUserAgent = /Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  return isIOS || isAndroid || isTouchDevice && isMobileUserAgent;
};
export default isMobileDevice;